var render = function render(){var _vm=this,_c=_vm._self._c;return _c('interstitial-content',_vm._b({},'interstitial-content',_vm.interstitialContent,false))
}
var staticRenderFns = []

export { render, staticRenderFns }